import helper from '../helpers/api';

const resource = 'role';

export default {
  ...helper(resource),
};
